/* tslint:disable */
/* eslint-disable */
/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum ERepairerCaseRequest {
    WaitingConfirm = 'WaitingConfirm',
    OnGoing = 'OnGoing',
    All = 'All',
    Pending = 'Pending',
    Open = 'Open',
    Closed = 'Closed',
    WaitingPayment = 'WaitingPayment'
}


